"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _redial = require("redial");

var _reactRedux = require("react-redux");

var _glamor = require("glamor");

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _ProductReleases = require("./Components/ProductReleases");

var _ProductReleases2 = _interopRequireDefault(_ProductReleases);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _softwares = require("../../redux/modules/softwares");

var _utils = require("../../utils");

var _components = require("../../components");

var _selectors = require("../../EpicMigration/selectors");

var _MixerTermsPopup = require("../../EpicEula/MixerTermsPopup");

var _MixerTermsPopup2 = _interopRequireDefault(_MixerTermsPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var page = (0, _glamor.css)({
  maxWidth: (0, _css.unitRem)(46),
  padding: (0, _css.unitRem)(5) + " " + (0, _css.unitRem)(3),

  margin: "auto"
});

var iconCss = (0, _glamor.css)({
  width: 72,
  height: 72
});

var icon = _react2.default.createElement("img", { className: iconCss, src: "/icons/mixer_icon_2048_preview.png" });

var MixerContainer = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        params = _ref.params;

    var _getState = getState(),
        softwares = _getState.softwares;

    if (softwares.mixerUpdater.length === 0) {
      return dispatch((0, _softwares.loadMixerUpdater)());
    }
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    softwares: state.softwares,
    isMixerEulaAccepted: (0, _selectors.isMixerEulaAccepted)(state),
    isEpicLogin: (0, _selectors.selectIsEpicLogin)(state)
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(MixerContainer, _React$Component);

  function MixerContainer(props) {
    (0, _classCallCheck3.default)(this, MixerContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MixerContainer.__proto__ || (0, _getPrototypeOf2.default)(MixerContainer)).call(this, props));

    _this.state = {
      platform: "Windows"
    };

    _this.handleMixerEULA = _this.handleMixerEULA.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(MixerContainer, [{
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({ platform: e.target.value });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({
        platform: platform === "Linux" ? "Windows" : platform
      });
    }
  }, {
    key: "handleMixerEULA",
    value: function handleMixerEULA() {
      this.context.dialogs.custom(_react2.default.createElement(_MixerTermsPopup2.default, null));
    }
  }, {
    key: "transformFeed",
    value: function transformFeed(feed) {
      var _props = this.props,
          isMixerEulaAccepted = _props.isMixerEulaAccepted,
          isEpicLogin = _props.isEpicLogin;

      var versions = [];

      _underscore2.default.rest(feed).forEach(function (f) {
        if (!!f.Url) {
          var win = {
            icon: icon,
            platform: "Windows",
            title: "Quixel Mixer v" + (0, _utils.prettyVersion)(f.Version) + " for Windows",
            buttons: [{
              label: "Release Notes",
              to: "/products/mixer/win/" + f.Version
            }],
            download: {
              label: "Download",
              url: f.Url,
              onClick: function onClick() {
                if (window && _epicTracking) {
                  window.trackEpicIntrection({
                    eventCategory: "Software",
                    eventAction: "Download",
                    eventLabel: "Mixer - " + f.Version,
                    interactionType: "click",
                    eventValue: 100
                  });
                }
              }
            }
          };

          versions.push(win);
        }

        if (!!f.UrlMac) {
          var mac = {
            icon: icon,
            platform: "Mac",
            title: "Quixel Mixer v" + (0, _utils.prettyVersion)(f.Version) + " for Mac",
            buttons: [{
              label: "Release Notes",
              to: "/megascans/library/products/mixer/mac/" + f.Version
            }],

            download: {
              label: "Download",
              url: f.UrlMac,
              onClick: function onClick() {
                if (window && _epicTracking) {
                  window.trackEpicIntrection({
                    eventCategory: "Software",
                    eventAction: "Download",
                    eventLabel: "Mixer - " + f.Version,
                    interactionType: "click",
                    eventValue: 100
                  });
                }
              }
            }
          };

          versions.push(mac);
        }
      });

      return versions;
    }
  }, {
    key: "render",
    value: function render() {
      var platform = this.state.platform;
      var _props2 = this.props,
          softwares = _props2.softwares,
          isMixerEulaAccepted = _props2.isMixerEulaAccepted;


      var loading = softwares.loadingMixer;
      var loaded = softwares.mixerLoaded;
      var updater = softwares.mixerUpdater;

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Mixer | Download Mixer for Windows or Mac",
          documentDescription: "Download any version of Quixel Mixer for Windows or Mac. Check the release notes for improvements and bug fixes."
        },
        _react2.default.createElement(
          "div",
          { className: page },
          _react2.default.createElement(_ProductReleases2.default, {
            products: this.transformFeed(updater),
            filter: platform,
            setFilter: this.handleChange.bind(this)
          })
        )
      );
    }
  }]);
  return MixerContainer;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = MixerContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Mixer/Mixer.jsx
// module id = 2941
// module chunks = 0